import { makeApiActionCreatorV3 } from '@actions/utils';

import * as api from '../api/hearing';

const namespace = 'ASSESSMENT';

export const HEARINGS_FETCH_START = `${namespace}/HEARINGS_FETCH_START`;
export const HEARINGS_FETCH_SUCCESS = `${namespace}/HEARINGS_FETCH_SUCCESS`;
export const HEARINGS_FETCH_ERROR = `${namespace}/HEARINGS_FETCH_ERROR`;

export const CREATE_HEARING_START = `${namespace}/CREATE_HEARING_START`;
export const CREATE_HEARING_SUCCESS = `${namespace}/CREATE_HEARING_SUCCESS`;
export const CREATE_HEARING_ERROR = `${namespace}/CREATE_HEARING_ERROR`;

export const UPDATE_HEARING_START = `${namespace}/UPDATE_HEARING_START`;
export const UPDATE_HEARING_SUCCESS = `${namespace}/UPDATE_HEARING_SUCCESS`;
export const UPDATE_HEARING_ERROR = `${namespace}/UPDATE_HEARING_ERROR`;

export const DELETE_HEARING_START = `${namespace}/DELETE_HEARING_START`;
export const DELETE_HEARING_SUCCESS = `${namespace}/DELETE_HEARING_SUCCESS`;
export const DELETE_HEARING_ERROR = `${namespace}/DELETE_HEARING_ERROR`;

export const CREATE_HEARING_NOTICE_START = `${namespace}/CREATE_HEARING_NOTICE_START`;
export const CREATE_HEARING_NOTICE_SUCCESS = `${namespace}/CREATE_HEARING_NOTICE_SUCCESS`;
export const CREATE_HEARING_NOTICE_ERROR = `${namespace}/CREATE_HEARING_NOTICE_ERROR`;

export const DELETE_HEARING_NOTICE_START = `${namespace}/DELETE_HEARING_NOTICE_START`;
export const DELETE_HEARING_NOTICE_SUCCESS = `${namespace}/DELETE_HEARING_NOTICE_SUCCESS`;
export const DELETE_HEARING_NOTICE_ERROR = `${namespace}/DELETE_HEARING_NOTICE_ERROR`;

export const GET_HEARING_NOTICE_START = `${namespace}/GET_HEARING_NOTICE_START`;
export const GET_HEARING_NOTICE_SUCCESS = `${namespace}/GET_HEARING_NOTICE_SUCCESS`;
export const GET_HEARING_NOTICE_ERROR = `${namespace}/GET_HEARING_NOTICE_ERROR`;

export const fetchHearings = makeApiActionCreatorV3(
  api.fetchHearings,
  HEARINGS_FETCH_START,
  HEARINGS_FETCH_SUCCESS,
  HEARINGS_FETCH_ERROR,
);

export const createHearing = makeApiActionCreatorV3(
  api.createHearing,
  CREATE_HEARING_START,
  CREATE_HEARING_SUCCESS,
  CREATE_HEARING_ERROR,
);

export const updateHearing = makeApiActionCreatorV3(
  api.updateHearing,
  UPDATE_HEARING_START,
  UPDATE_HEARING_SUCCESS,
  UPDATE_HEARING_ERROR,
);

export const deleteHearing = makeApiActionCreatorV3(
  api.deleteHearing,
  DELETE_HEARING_START,
  DELETE_HEARING_SUCCESS,
  DELETE_HEARING_ERROR,
);

export const createHearingNotice = makeApiActionCreatorV3(
  api.createHearingNotice,
  CREATE_HEARING_NOTICE_START,
  CREATE_HEARING_NOTICE_SUCCESS,
  CREATE_HEARING_NOTICE_ERROR,
);

export const deleteHearingNotice = makeApiActionCreatorV3(
  api.deleteHearingNotice,
  DELETE_HEARING_NOTICE_START,
  DELETE_HEARING_NOTICE_SUCCESS,
  DELETE_HEARING_NOTICE_ERROR,
);

export const getHearingNotice = makeApiActionCreatorV3(
  api.getHearingNotice,
  GET_HEARING_NOTICE_START,
  GET_HEARING_NOTICE_SUCCESS,
  GET_HEARING_NOTICE_ERROR,
);
